/*** IMPORTS FROM imports-loader ***/
var define = false;

import '../../../scss/app/register.scss';

document.getElementById('register_firstName').focus();

